export class FileCollection {
    constructor(files) {
        this.files = files;
    }
    filter(callback) {
        return new FileCollection(this.files.filter(callback));
    }
    [Symbol.iterator]() {
        return this.files.values();
    }
}
//# sourceMappingURL=FileCollection.js.map